import React, { useEffect, useState, useRef } from 'react';
import '../Styles/Gallery.css';
import img1 from '../Resource/MapInfo/madura-img1.png';
import img2 from '../Resource/MapInfo/milan-img1.png';
// import img3 from '../Resource/MapInfo/shama-img1.png';
import img4 from '../Resource/MapInfo/sukhee-img1.png';
import img5 from '../Resource/MapInfo/suvidha-img1.png';
import video1 from '../Resource/Gallery/video1.mp4';
import video2 from '../Resource/Gallery/video2.mp4';
import realvdo1 from '../Resource/Gallery/gal-vdo1.mp4'
import realvdo2 from '../Resource/Gallery/gal-vdo2.mp4'
import GalleryPopUp from './GalleryPopUp';
import live_img1 from '../Resource/Gallery/new_live_img1.png'
import live_img2 from '../Resource/Gallery/new_live_img2.png'
import live_img3 from '../Resource/Gallery/new_live_img3.png'
import reel1 from '../Resource/Gallery/Reel1.mp4'
import reel2 from '../Resource/Gallery/Reel2.mp4'
import reel3 from '../Resource/Gallery/Reel3.mp4'


const galleryData = [
  {
    title: '3D Images',
    items: [img1, img2,img4,img5],
    type: 'image',
    delay: 0,
  },
  {
    title: 'Live Images',
    items: [live_img1, live_img2, live_img3],
    type: 'image',
    delay: 2000,
  },
  {
    title: 'Reels',
    items: [reel1, reel2,reel3],
    type: 'video',
    delay: 4000,
  },
  {
    title: 'Videos',
    items: [realvdo2, realvdo1],
    type: 'video',
    delay: 6000,
  },
];

const Gallery = () => {
  const [showPopup, setShowPopup] = useState(false);

const galleryContainerRef = useRef(null);

useEffect(() => {
  if (showPopup && galleryContainerRef.current) {
    const topOffset = galleryContainerRef.current.getBoundingClientRect().top + window.scrollY;
    const scrollTarget = topOffset + (window.innerWidth * 0.2); // Add 3vw offset

    window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }

  return () => {
    document.body.style.overflow = 'auto';
  };
}, [showPopup]);

  const handleOpenPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  return (
    <div className="Gallery-container" id="Gallery" ref={galleryContainerRef}>
      <div className="Gallery-header">Gallery</div>

      <div className="Gallery-main-section-holder">
        {galleryData.map((section, index) => (
          <GallerySection
            key={index}
            items={section.items}
            type={section.type}
            title={section.title}
            delay={section.delay}
          />
        ))}
      </div>

      <div className="Gallery-view-gallery-button" onClick={handleOpenPopup}>
        VIEW FULL GALLERY
      </div>

      {showPopup && (
  <div className="gallery-popup-wrapper" onClick={handleClosePopup}>
    <div className="gallery-popup-overlay" />
    <div className="gallery-popup-content" onClick={(e) => e.stopPropagation()}>
      <GalleryPopUp 
        handleClosePopup={handleClosePopup}
        galleryData={galleryData}
      />
    </div>
  </div>
)}
    </div>
  );
};

const GallerySection = ({ items, type, title, delay }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  const videoRef = useRef(null);
  const intervalRef = useRef(null);
  const startTimeoutRef = useRef(null);

  const goToNext = () => {
    setAnimate(true);
    setCurrentIndex((prev) => (prev + 1) % items.length);
  };

  const goToIndex = (index) => {
    setAnimate(true);
    setCurrentIndex(index);
  };

  const handleVideoEnd = () => {
    goToNext();
  };

  useEffect(() => {
    if (type === 'image') {
      startTimeoutRef.current = setTimeout(() => {
        intervalRef.current = setInterval(goToNext, 3000);
      }, delay);
    } else {
      startTimeoutRef.current = setTimeout(() => {
        const video = videoRef.current;
        if (video) {
          video.addEventListener('ended', handleVideoEnd);
        }
      }, delay);
    }

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(startTimeoutRef.current);
      if (videoRef.current) {
        videoRef.current.removeEventListener('ended', handleVideoEnd);
      }
    };
  }, [currentIndex]);

  const currentItem = items[currentIndex];

  return (
    <div>
      <div className="Gallery-image-holder">
        {type === 'video' ? (
          <video
            ref={videoRef}
            src={currentItem}
            className={`Gallery-image ${animate ? 'slide-in' : ''}`}
            autoPlay
            muted
            playsInline
            onPlay={() => setAnimate(false)}
          />
        ) : (
          <img
            src={currentItem}
            alt={`media-${currentIndex}`}
            className={`Gallery-image ${animate ? 'slide-in' : ''}`}
            onLoad={() => setAnimate(false)}
          />
        )}

        <div className="Gallery-pagination-dots-holder">
          <div className="Gallery-pagination-dots-holder-background-highlighter">
            {items.map((_, i) => (
              <div
                key={i}
                className={i === currentIndex ? 'pagination-dot-active' : 'pagination-dot'}
                onClick={() => goToIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="Gallery-bottom-title">{title}</div>
    </div>
  );
};

export default Gallery;
